import { useEffect } from "react";

import { useRealTimeTypedQuery } from "components/WebSocket/hooks";
import { useLeadsSnoozedFilters } from "modules/LeadsDashboard/Leads/SnoozedLeads/hooks";
import { useSnoozedLeadsListeners } from "modules/LeadsDashboard/Leads/SnoozedLeads/listeners";
import { LeadsQueryKeys } from "modules/LeadsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";
import { groupAndSortPaginatedItems } from "utils/paginatedItems";

import type { LeadsSnoozedFilters } from "modules/LeadsDashboard/queryKeys";

export const hasRequiredSnoozedFilters = (snoozedFilters: LeadsSnoozedFilters) => {
  const hasDealerLocationSelected = snoozedFilters.location_ids.length > 0 || snoozedFilters.dealer_ids.length > 0;
  const hasSnoozeDateRangeSelected = snoozedFilters.snooze_date_from && snoozedFilters.snooze_date_to;
  const hasAppointmentDateRangeSelected = snoozedFilters.appointment_date_from && snoozedFilters.appointment_date_to;

  return hasDealerLocationSelected && Boolean(hasAppointmentDateRangeSelected || hasSnoozeDateRangeSelected);
};

export const useLeadsSnoozedQuery = () => {
  const snoozedFilters = useLeadsSnoozedFilters();
  const listeners = useSnoozedLeadsListeners();

  const query = useRealTimeTypedQuery({
    queryKey: LeadsQueryKeys.listSnoozed,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.post(endpoint, snoozedFilters, baseUrl)).data,
    select: groupAndSortPaginatedItems,
    enabled: false,
    listeners
  });

  useEffect(() => {
    if (hasRequiredSnoozedFilters(snoozedFilters)) query.refetch();
  }, [snoozedFilters]);

  return query;
};
